export default (state = [], action) => {
	switch (action.type) {
		case "FETCH_CREATORS_FULFILLED":
			return action.payload;
		case "FETCH_CREATOR_FULFILLED":
			return action.payload;
		default:
			return state;
	}
};
